import { render, staticRenderFns } from "./InputTextarea.vue?vue&type=template&id=244846ce&scoped=true&"
import script from "./InputTextarea.vue?vue&type=script&lang=js&"
export * from "./InputTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244846ce",
  null
  
)

export default component.exports